<template>
    <v-btn class="theme-background ma-0 mb-2 flex-grow-1" :class="selected === reason ? 'theme-green-border' : 'theme-border'" width="100%" min-height="44px" outlined @click="selectRejectReason">
        {{ getRejectReasonLabel() }}
    </v-btn>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from "@/constants";

    export default {
        name: 'RejectReasonButton',
        props: {
            reason: String,
            selected: String,
            reasons: Object
        },
        methods: {
            selectRejectReason: function () {
                eventBus.$emit(CONSTANTS.DMR.SELECT_REJECT_REASON, this.reason);
            },
            getRejectReasonLabel: function () {
                return this.reasons[this.reason];
            },
        }
    }
</script>
